export const TOOLTIPS = {
  hourly: {
    overview: {
      budgetVsAchieved:
        "Indicates performance against the budgeted margin: below 100 indicates underperformance, 100 indicates expected performance, and above 100 indicates exceptional performance.",
      nextBillingDate: "The date when the next billing period is scheduled based on the Job Config.",
      loggedVsApproved: "Shows comparision between Approved hours against Logged hours.",
      milestoneConfigHoursDifference:
        "Shows the difference between total milestone billable hours and total billable config hours. Indicates whether an advance billable has been generated or backlog hours need to be billed.",
    },
    lifetimeBillableSummary: {
      billable: "Total hours that are eligible to be billed to the client till date.",
      billed: "Total hours that have been billed to the client.",
      backlogAdvance: "Shows the difference between billable and billed hours. A positive value is backlog; a negative value indicates an advance.",
    },
    lastBillableSummary: {
      billable: "Hours of work delivered that were eligible to be billed in the latest billing period.",
      billed: "Hours of work that were billed in the latest billing period.",
    },
  },
  dedicated: {
    overview: {
      budgetVsAchieved:
        "Indicates performance against the budgeted margin: below 100 indicates underperformance, 100 indicates expected performance, and above 100 indicates exceptional performance.",
      nextBillingDate: "The date when the next billing period is scheduled based on the Job Config.",
      timelineInMonths: "Shows the job duration in months, calculated based on the actual working days.",
    },
    lifetimeBillableSummary: {
      total: "Total hours of work delivered from the start date till the end date of the Job.",
      consumedVsSpent:
        "Shows consumed hours compared to spent hours. Consumed is based on approved hours and the consumption factor; spent is based on logged hours and the consumption factor.",
    },
    activeBillable: {
      total: "Total hours of work delivered in the current billing period to this date.",
      consumedVsSpent:
        "Shows consumed hours compared to spent hours. Consumed is based on approved hours and the consumption factor; spent is based on logged hours and the consumption factor.",
    },
  },
  bucket: {
    overview: {
      budgetVsAchieved:
        "Indicates performance against the budgeted margin: below 100 indicates underperformance, 100 indicates expected performance, and above 100 indicates exceptional performance.",
      targetHoursToRedeem: "Shows the total number of hours available to be redeemed from the bucket for the next milestone.",
      total: "Total hours purchased in the bucket.",
      redeemed: "Shows the total number of hours purchased in the bucket.",
      remaining: "Shows the number of hours remaining to be redeemed from the bucket.",
      billable: "Total hours that are eligible to be billed to the client till date.",
      loggedVsApproved: "Shows comparision between Approved hours against Logged hours.",
    },
  },
  recurring: {
    overview: {
      budgetVsAchieved:
        "Indicates performance against the budgeted margin: below 100 indicates underperformance, 100 indicates expected performance, and above 100 indicates exceptional performance.",
      loggedVsApproved: "Shows comparision between Approved hours against Logged hours.",
      nextRenewalDate: "The date when the job will be renewed for the next billing period.",
    },
    activeBillable: {
      billingFrequency: "Shows how often the client is billed for the job.",
      interval: "Shows the recurring billing interval between billing cycles.",
      activeIntervalProgress: "Shows the progress of the current billing interval.",
    },
  },
  fixed: {
    overview: {
      budgetVsAchieved:
        "Indicates performance against the budgeted margin: below 100 indicates underperformance, 100 indicates expected performance, and above 100 indicates exceptional performance.",
      allocatedHours: "Total hours allocated to the job for the work.",
      consumedVsSpent:
        "Shows consumed hours compared to spent hours. Consumed is based on approved hours and the consumption factor; spent is based on logged hours and the consumption factor.",
      remainingAllocatedHours: "Hours remaining from the allocated hours for the job.",
      effortProgress: "Shows the percentage of allocated hours spent on the Job.",
    },
  },
};